/** Runtime config from /config.js (served by the FarmAI API); Vite env vars in local dev. */
interface RuntimeConfig {
  supabaseUrl?: string;
  supabaseAnonKey?: string;
  vapidPublicKey?: string;
  farmosOrigin?: string;
}

declare global {
  interface Window {
    __FARMAI_CONFIG__?: RuntimeConfig;
  }
}

const rc: RuntimeConfig = (typeof window !== 'undefined' && window.__FARMAI_CONFIG__) || {};

function required(name: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing configuration: ${name}`);
  return value;
}

export const env = {
  supabaseUrl: required('supabaseUrl', rc.supabaseUrl || import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required(
    'supabaseAnonKey',
    rc.supabaseAnonKey || import.meta.env.VITE_SUPABASE_ANON_KEY,
  ),
  vapidPublicKey: rc.vapidPublicKey || undefined,
  farmosOrigin: rc.farmosOrigin || undefined,
};
